<script setup lang="ts">
import LeTopBanner from "@dsk/components/LeTopBanner.vue";
import { useI18n } from "vue-i18n";

import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory, type WriteAssistantPromotion } from "@/types";

const props = defineProps<{
  promotion: WriteAssistantPromotion;
}>();

const { t } = useI18n();

const openLink = () => {
  MatomoHelper.sendEvent(
    MatomoEventCategory.WriteAssistantPromotion,
    MatomoEventAction.ClickBannerLink,
    `Clicked on "${props.promotion.type}" promotion`
  );

  window.open(props.promotion.url, "_blank");
};
</script>

<template>
  <LeTopBanner type="neutral">
    <i18n-t v-if="props.promotion.type === 'app'" tag="span" keypath="banners.write-assistant-promotion.app.text">
      <template #name>
        <a class="link" tabindex="1" @click="openLink()" @keydown.enter="openLink()">
          {{ t("banners.write-assistant-promotion.app.name") }}
        </a>
      </template>
      <template #link>
        <a class="link" tabindex="1" @click="openLink()" @keydown.enter="openLink()">
          {{ t("banners.write-assistant-promotion.app.link") }}
        </a>
      </template>
    </i18n-t>
    <i18n-t v-else tag="span" keypath="banners.write-assistant-promotion.web.text">
      <template #name>
        <a class="link" tabindex="1" @click="openLink()" @keydown.enter="openLink()">
          {{ t("banners.write-assistant-promotion.web.name") }}
        </a>
      </template>
      <template #link>
        <a class="link" tabindex="1" @click="openLink()" @keydown.enter="openLink()">
          {{ t("banners.write-assistant-promotion.web.link") }}
        </a>
      </template>
    </i18n-t>
  </LeTopBanner>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.link {
  cursor: pointer;
}
</style>
